export default {
      id: "crown-usage",
      viewBox: "0 0 14 11",
      url: __webpack_public_path__ + "sprite-46b249.svg#crown-usage",
      toString: function () {
        return this.url;
      }
    }